import { render } from "./TermsComponent.vue?vue&type=template&id=45556164&scoped=true"
import script from "./TermsComponent.vue?vue&type=script&lang=js"
export * from "./TermsComponent.vue?vue&type=script&lang=js"

import "./TermsComponent.vue?vue&type=style&index=0&id=45556164&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45556164"]])

export default __exports__